import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
// Dependencies.
import styled, { css } from 'styled-components'

import { Page as PAGE } from '../../components/Page'
import { ForgotPasswordForm } from '../../components/Forms/ForgotPasswordForm'
import { forScreensGreaterThanMobileWidth } from '../../utils'

// Page.
const Page = styled(PAGE)`
  padding-top: 80px;
  ${forScreensGreaterThanMobileWidth(css`
    padding-top: 100px;
  `)}
`

// Props.
interface Props {}

// Forgot Password.
export const ForgotPasswordPage: React.FC<Props> = (props) => {
  // ..
  return (
    <Page>
      {/* Form. */}
      <ForgotPasswordForm />
    </Page>
  )
}

// Export.
export default ForgotPasswordPage
export async function getStaticProps({ locale }) {
  const translations = await serverSideTranslations(locale, ['common'])
  return {
    props: {
      ...translations,
    },
  }
}
